const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/PatAppRouter.tsx';
import { Redirect, Route, Router as ReactRouter, Switch } from 'react-router-dom';

import { App } from './layout/App/App';
import { ProtectedRoute } from './layout/ProtectedRoute';
import { RedirectWithQueryParams } from './layout/RedirectWithQueryParams';
import { Footer } from './components/Footer/Footer';
import * as React from 'react';
import { useEffect } from 'react';
import { routerHistory } from './store/setup/configureStore';
import useBreakpoint from '@cistec/common_web/hooks/useBreakpoint';
import DataTrackingPopup from 'App/pages/DataTrackingPopup/DataTrackingPopup';
import { useSelector } from 'react-redux';
import { TrackingState } from './defs/trackingDefs';
import { hasNativeWrapper } from './utils/generalUtils';
import { AppointmentsPage } from './pages/appointment/AppointmentsPage';
import { BookAppointmentPage } from './pages/appointment/BookAppointmentPage';
import { DashboardPage } from './pages/DashboardPage/DashboardPage';
import { DeveloperPage } from './pages/DeveloperPage/DeveloperPage';
import { ExternalPage } from './pages/ExternalPage/ExternalPage';
import { InvoicePage } from './pages/InvoicePage/InvoicePage';
import { MediPage } from './pages/MediPage/MediPage';
import { ReportPage } from './pages/ReportPage/ReportPage';
import { StartPage } from './pages/StartPage/StartPage';
import { SynedraIFrameViewerPage } from './pages/SynedraIFrameViewerPage/SynedraIFrameViewerPage';
import { useTheme } from '@mui/material/styles';
import { ReschedulePage } from './pages/appointment/ReschedulePage';
import { AppointmentPage } from './pages/appointment/AppointmentPage';
import { BookingConfirmationPage } from './pages/appointment/BookingConfirmationPage';
import { RescheduleConfirmationPage } from './pages/appointment/RescheduleConfirmationPage';

import {
    PATH_APPOINTMENT,
    PATH_APPOINTMENT_BOOKING,
    PATH_APPOINTMENT_BOOKING_CONFIRMATION,
    PATH_APPOINTMENT_RESCHEDULE,
    PATH_APPOINTMENT_RESCHEDULE_CONFIRMATION,
    PATH_APPOINTMENT_SUBLIMD_FRAME,
    PATH_APPOINTMENTS,
    PATH_DASHBOARD,
    PATH_INVOICES,
    PATH_MEDIS,
    PATH_REPORTS,
} from './defs/router';
import { useFeatureFlags } from './store/featureFlags';
import { trackingSelector } from './store/tracking';
import { SnackbarWrapper } from './components/Snackbar/Snackbar';
import { SublimdPage } from './pages/SublimdPage/SublimdPage';
import { getConfiguration } from './utils/clientSetupGetRessource';
import { addAiAiBot } from './utils/aiaibot';

export const PatAppRouter = () => {
    const theme = useTheme();
    const isMediumDevice = useBreakpoint(theme?.breakpoints?.values?.md);

    const trackingState = useSelector(trackingSelector);
    const noPermission = (trackingState as unknown as string) === TrackingState.NO_PERMISSION_AVAILABLE;

    const { data: featureFlags } = useFeatureFlags();

    const { aiaiBotApiKey } = getConfiguration();

    useEffect(() => {
        // AiAiBot is not working for development due to not allowing http://localhost
        if (process.env.NODE_ENV !== 'development') {
            addAiAiBot(aiaiBotApiKey);
        }
    }, [aiaiBotApiKey]);

    return (
        <App>
            <ReactRouter history={routerHistory}>
                <Switch>
                    {featureFlags.login.allowIAM ? <Route path="/app/start" component={StartPage} /> : null}
                    <Route path="/app/login/invitation-code" component={StartPage} />
                    {process.env.NODE_ENV !== 'production' && (
                        <Route path="/app/123developer-page" component={DeveloperPage} />
                    )}
                    <ProtectedRoute path="/app/*">
                        <Switch>
                            <Route path={PATH_APPOINTMENT_BOOKING} component={BookAppointmentPage} />
                            <Route path={PATH_APPOINTMENT_RESCHEDULE} component={ReschedulePage} />
                            <Route
                                path={PATH_APPOINTMENT_BOOKING_CONFIRMATION}
                                component={BookingConfirmationPage}
                            />
                            <Route
                                path={PATH_APPOINTMENT_RESCHEDULE_CONFIRMATION}
                                component={RescheduleConfirmationPage}
                            />
                            <Route path={PATH_APPOINTMENT} component={AppointmentPage} />
                            <Route path={PATH_APPOINTMENTS} component={AppointmentsPage} />
                            <Route path={PATH_APPOINTMENT_SUBLIMD_FRAME} component={SublimdPage} />
                            <Route path={PATH_DASHBOARD} component={DashboardPage} />
                            <Route path={PATH_MEDIS} component={MediPage} />
                            <Route path={PATH_REPORTS} component={ReportPage} />
                            <Route path={PATH_INVOICES} component={InvoicePage} />
                            <Route path="/app/synedraViewer" component={SynedraIFrameViewerPage} />
                            <Route path="/app/external/:title/:url" component={ExternalPage} />
                            <Redirect to="/app/login/invitation-code" />
                        </Switch>
                    </ProtectedRoute>
                    <Route path="*" component={RedirectWithQueryParams} />
                </Switch>
            </ReactRouter>
            <SnackbarWrapper />
            {!isMediumDevice && <Footer />}
            {((!hasNativeWrapper && featureFlags.utils.allowMatamoTrack) ||
                (featureFlags.utils.allowMatamoTrack && hasNativeWrapper && noPermission)) && <DataTrackingPopup />}
        </App>
    );
};
